/** `cond && value` en liste : garde les entrées vraies, jette `false` / `undefined` / `null`. */
export function compact<T>(items: (T | false | undefined | null)[]): T[] {
    return items.filter(Boolean) as T[]
}
